import { render, staticRenderFns } from "./FIBFakeInput.vue?vue&type=template&id=e225bec2&scoped=true&"
import script from "./FIBFakeInput.vue?vue&type=script&lang=js&"
export * from "./FIBFakeInput.vue?vue&type=script&lang=js&"
import style0 from "./FIBFakeInput.vue?vue&type=style&index=0&id=e225bec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e225bec2",
  null
  
)

export default component.exports